import request from "@/utils/request";

export function getTrainingKits() {
  return request({
    url: "/api/tutordata/TrainingKits",
    method: "post",
  });
}

export function getTrainingKitModel(primaryID) {
  return request({
    url: "/api/tutordata/TrainingKitModel?primaryID=" + primaryID,
    method: "post",
  });
}

export function getKCTList(kctId) {
  return request({
    url: "/api/tutordata/KCTList?kctId=" + kctId,
    method: "post",
  });
}

export function learnSubmit(TrakitId, UsedTime, IsCompleteCourse) {
  return request({
    url:
      "/api/TutorData/LearnSubmit?TrakitId=" +
      TrakitId +
      "&UsedTime=" +
      UsedTime +
      "&IsCompleteCourse=" +
      IsCompleteCourse,
    method: "post",
  });
}

export function testSubmit(data, kctId, startTime, IsCompleteCourse) {
  return request({
    url:
      "/api/TutorData/TestSubmit?kctId=" +
      kctId +
      "&startTime=" +
      startTime +
      "&IsCompleteCourse=" +
      IsCompleteCourse,
    method: "post",
    data,
  });
}

export function getTestScore(recodeId) {
  const id = recodeId == null || recodeId === "undefined" ? "" : String(recodeId);
  return request({
    url: "/api/TutorData/GetTestScore?recodeId=" + encodeURIComponent(id),
    method: "post",
  });
}

export function addTutorLabel(kctId) {
  return request({
    url: "/api/TutorData/AddTutorLabel?kctId=" + kctId,
    method: "post",
  });
}

/** Teaching Dynamics */
export function getTutorClassInfo() {
  return request({
    url: "/api/tutordata/TutorClassInfo",
    method: "post",
  });
}

/** Home ranking summary flags + data */
export function getRankingSummary() {
  return request({
    url: "/api/tutordata/GetRankingSummary",
    method: "post",
  });
}

/** Received orders ranking */
export function GetDidiReceivedRankingList(pageIndex, pageSize) {
  return request({
    url:
      "/api/tutordata/GetDidiReceivedRankingList?pageIndex=" +
      pageIndex +
      "&pageSize=" +
      pageSize,
    method: "post",
  });
}

/** 10s response rate ranking */
export function getDidiResponseRankingList(pageIndex, pageSize) {
  return request({
    url:
      "/api/tutordata/GetDidiResponseRankingList?pageIndex=" +
      pageIndex +
      "&pageSize=" +
      pageSize,
    method: "post",
  });
}

/** Emotional / course feel ranking */
export function getCourseFeelRankingList(pageIndex, pageSize) {
  return request({
    url:
      "/api/tutordata/GetCourseFeelRankingList?pageIndex=" +
      pageIndex +
      "&pageSize=" +
      pageSize,
    method: "post",
  });
}

/** Trial conversion overall leaderboard */
export function getConversionOverallLeaderboard(pageIndex, pageSize) {
  return request({
    url:
      "/api/tutordata/GetConversionOverallLeaderboard?pageIndex=" +
      pageIndex +
      "&pageSize=" +
      pageSize,
    method: "post",
  });
}

/** EB detail list under conversion ranking */
export function getEBDetailList(param) {
  return request({
    url: "/api/TutorData/GetEBDetailList",
    method: "post",
    data: param,
  });
}

/** Assessment — Quality Flagged Lessons list */
export function getVipClassQualityInspectionList(param) {
  return request({
    url: "/api/TutorData/GetVipClassQualityInspectionList",
    method: "post",
    timeout: 5 * 60 * 1000 * 1000,
    data: param,
  });
}

/** Assessment — Quality Flagged Lessons issue content */
export function getVipClassQualityInspectionContent(param) {
  return request({
    url: "/api/TutorData/GetVipClassQualityInspectionContent",
    method: "post",
    data: param,
  });
}

/** Assessment — Quality Flagged Lessons submit appeal */
export function submitVipClassQualityInspectionApply(param) {
  return request({
    url: "/api/TutorData/SubmitVipClassQualityInspectionApply",
    method: "post",
    data: param,
  });
}

/** Assessment — Quality Flagged Lessons appeal detail */
export function getVipClassQualityInspectionApplyDetail(clid) {
  return request({
    url: "/api/TutorData/GetVipClassQualityInspectionApplyDetail?clid=" + clid,
    method: "post",
  });
}

/** Assessment — pronunciation correction performance */
export function getCoursePerformanceList(param) {
  return request({
    url: "/api/TutorData/GetCoursePerformanceList",
    method: "post",
    timeout: 5 * 60 * 1000 * 1000,
    data: param,
  });
}

/** Assessment — live microphone ledger */
export function getLiveMicrophoneLedgerForTutor(param) {
  return request({
    url: "/api/TutorData/GetLiveMicrophoneLedgerForTutor",
    method: "post",
    timeout: 5 * 60 * 1000 * 1000,
    data: param,
  });
}

/** Assessment — live microphone AI analysis */
export function getLiveMicrophoneAnalysisContent(id, type) {
  let url = `/api/TutorData/GetLiveMicrophoneAnalysisContent?id=${id}`;
  if (type) {
    url += `&type=${type}`;
  }
  return request({
    url,
    method: "post",
    timeout: 5 * 60 * 1000 * 1000,
  });
}

/** Assessment — classroom process list */
export function getLessonTeacherProcessList(param) {
  return request({
    url: "/api/TutorData/GetLessonTeacherProcessList",
    method: "post",
    timeout: 5 * 60 * 1000 * 1000,
    data: param,
  });
}

/** Assessment — classroom process AI analysis */
export function getLessonTeacherProcessAnalysisContent(id) {
  return request({
    url: `/api/TutorData/GetLessonTeacherProcessAnalysisContent?id=${id}`,
    method: "post",
    timeout: 5 * 60 * 1000 * 1000,
  });
}

/** Assessment — course finish analysis */
export function getCourseFinishAnalysis(id) {
  return request({
    url: `/api/TutorData/GetCourseFinishAnalysis?id=${id}`,
    method: "post",
  });
}

/** Assessment — R4 item analysis */
export function getR4ItemAnalysisContent(clid, id) {
  return request({
    url: `/api/TutorData/GetR4ItemAnalysisContentAsync?clid=${clid}&id=${id}`,
    method: "post",
  });
}

/** Assessment — questionnaire tip content */
export function getNewQuestionnaire(type) {
  return request({
    url: `/api/TutorData/GetNewQuestionnaire?type=${type}`,
    method: "post",
  });
}

/** Assessment — submit classroom process feedback */
export function submitLessonProcessFeedback(param) {
  return request({
    url: "/api/TutorData/SubmitLessonProcessFeedback",
    method: "post",
    data: param,
  });
}

/** Assessment — view classroom process feedback */
export function getLessonProcessFeedback(param) {
  return request({
    url: "/api/TutorData/GetLessonProcessFeedback",
    method: "post",
    data: param,
  });
}

/** Assessment — received complaints */
export function getCSComplaintsNew(pageIndex, pageSize) {
  return request({
    url:
      "/api/TutorData/GetCSComplaintsNew?pageIndex=" +
      pageIndex +
      "&pageSize=" +
      pageSize,
    method: "post",
  });
}

/** Assessment — late / leave early records */
export function getTeacherLateLeaveEarlyRecord(param) {
  return request({
    url: "/api/TutorData/TeacherLateLeaveEarlyRecord",
    method: "post",
    timeout: 5 * 60 * 1000 * 1000,
    data: param,
  });
}

/** Personal Data — profile dropdowns (equipment / network) */
export function getProfile() {
  return request({
    url: "/api/tutordata/Profile",
    method: "post",
  });
}

/** Integral Level — grade bands */
export function getGradeintegral() {
  return request({
    url: "/api/tutorcomm/Gradeintegral",
    method: "post",
  });
}

/** Enrolment — trial conversion count (Vue2 GetTutorTrail → Body number) */
export function getTutorTrail(tuid) {
  return request({
    url: "/api/tutordata/GetTutorTrail",
    method: "post",
    data: { tuid },
  });
}
